var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { StyledSearch, Wrapper, SearchIcon, ClearIcon, IWrap } from '../../Search.styles';
import { lastThree } from '../utils';
import { SearchTools } from './SearchTools';
var PrimarySearch = /** @class */ (function (_super) {
    __extends(PrimarySearch, _super);
    function PrimarySearch(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Return search to the previously submitted query
         */
        _this.resetQuery = function () {
            var node = _this.props.inputRef.current;
            if (node !== null) {
                node.value = _this.state.activeQuery;
                node.select();
            }
        };
        _this.setQuery = function (query, setNode) {
            if (query === void 0) { query = ''; }
            if (setNode === void 0) { setNode = false; }
            _this.setState(function (state) {
                if (query === state.activeQuery)
                    return state;
                // Avoid pushing empty queries to history
                var queryHistory = state.activeQuery !== '' &&
                    !state.queryHistory.includes(state.activeQuery)
                    ? __spreadArray(__spreadArray([], state.queryHistory), [state.activeQuery]) : state.queryHistory;
                return {
                    activeQuery: query,
                    queryHistory: queryHistory,
                    query: query,
                    showUpdate: false
                };
            }, function () {
                _this.props.onChange(query, _this.state.queryHistory);
                var node = _this.props.inputRef.current;
                if (node !== null && setNode) {
                    node.value = query;
                }
            });
        };
        /**
         * Real-time change handler for controlled search input
         */
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState(function (state) {
                var showUpdate = state.activeQuery !== value;
                return {
                    query: value,
                    showUpdate: showUpdate
                };
            });
        };
        /**
         * Handle enter and escape events
         * Enter: submit query
         * Escape: Reset input value to currently active query and highlight
         */
        _this.handleSearch = function (e) {
            if (e.key === 'Enter') {
                _this.setQuery(e.currentTarget.value);
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                _this.resetQuery();
            }
        };
        /**
         * Replaces currently active query with previous query
         */
        _this.handleSetRecent = function (pastQuery) { return function () {
            _this.setState({
                activeQuery: pastQuery,
                query: pastQuery,
                showUpdate: false
            }, function () {
                // Update search input node value
                var node = _this.props.inputRef.current;
                if (node !== null) {
                    node.value = pastQuery;
                }
                _this.props.onChange(pastQuery, _this.state.queryHistory);
            });
        }; };
        _this.handleClearSearch = function () {
            _this.setQuery('');
        };
        _this.handleUpdate = function () {
            _this.setQuery(_this.state.query);
        };
        _this.state = {
            query: '',
            queryHistory: props.initialHistory !== undefined ? __spreadArray([], props.initialHistory) : [],
            activeQuery: '',
            showUpdate: true
        };
        return _this;
    }
    PrimarySearch.prototype.componentDidMount = function () {
        var initial = this.props.initial;
        if (initial !== undefined) {
            this.setQuery(initial, true);
        }
    };
    PrimarySearch.prototype.render = function () {
        var _a = this.props, isEmpty = _a.isEmpty, placeholder = _a.placeholder, inputRef = _a.inputRef, thin = _a.thin, thick = _a.thick, inputClass = _a.inputClass, cy = _a.cy;
        var _b = this.state, showUpdate = _b.showUpdate, activeQuery = _b.activeQuery, queryHistory = _b.queryHistory;
        return (React.createElement(Wrapper, null,
            React.createElement(StyledSearch, { thin: thin, thick: thick },
                React.createElement("input", { "data-cy": cy, className: inputClass, "data-testid": "PrimarySearch-input", type: "search", onKeyDown: this.handleSearch, placeholder: placeholder, ref: inputRef, onChange: this.handleChange }),
                isEmpty || showUpdate ? (React.createElement(IWrap, { "data-testid": "PrimarySearch-search", appearance: "plain", onClick: this.handleUpdate, thin: thin, thick: thick },
                    React.createElement(SearchIcon, { className: "t-SearchIcon", thin: thin, thick: thick }))) : null,
                !isEmpty && !showUpdate ? (React.createElement(IWrap, { "data-testid": "PrimarySearch-clear", appearance: "plain", onClick: this.handleClearSearch, thin: thin, thick: thick },
                    React.createElement(ClearIcon, { className: "t-ClearIcon", small: true, thin: thin, thick: thick }))) : null),
            React.createElement(SearchTools, { active: activeQuery, recent: lastThree(queryHistory), onRecentClick: this.handleSetRecent, noResults: this.props.noResults })));
    };
    return PrimarySearch;
}(React.Component));
export { PrimarySearch };
//# sourceMappingURL=PrimarySearch.js.map